// Mirror of apps/api/src/lib/auth-permissions.ts. Better-auth requires
// the same access-control definition on both sides to keep permission
// checks consistent. Keep in lockstep with the API copy.

import { createAccessControl } from "better-auth/plugins/access";
import { adminAc, defaultStatements } from "better-auth/plugins/admin/access";

export const statement = {
	...defaultStatements,
} as const;

export const ac = createAccessControl(statement);

export const admin = ac.newRole({
	...adminAc.statements,
	user: ["impersonate-admins", ...adminAc.statements.user],
});

export const user = ac.newRole({});
